import { useNavigate } from "react-router-dom";
import { InstagramLogo, FacebookLogo, YoutubeLogo, WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { useSiteInfo, waLink } from "@/lib/site";

const Col = ({ title, links, navigate }) => (
  <div>
    <p className="mb-3 text-xs font-bold uppercase tracking-wider text-stone-400">{title}</p>
    <ul className="space-y-2">
      {links.map((l) => (
        <li key={l.label}>
          <button data-testid={`footer-${l.label.replace(/\s+/g, "-").toLowerCase()}`} onClick={() => navigate(l.to)} className="text-sm text-stone-300 transition-colors hover:text-white">{l.label}</button>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const navigate = useNavigate();
  const info = useSiteInfo();
  const social = info.social || {};
  return (
    <footer className="mt-16 bg-stone-900 px-6 py-12 text-stone-200" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-10 md:grid-cols-5">
        <div className="md:col-span-1">
          <p className="font-heading text-xl font-extrabold tracking-tight text-white">Avinya <span className="text-primary">Bookings</span></p>
          <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.28em] text-amber-500">Book · Relax · Celebrate</p>
          <p className="mt-4 text-sm text-stone-400">Discover and book farmhouses, resorts, banquet halls and function halls around Hyderabad.</p>
          <div className="mt-4 flex gap-3">
            {social.instagram && <a href={social.instagram} aria-label="Instagram" className="text-stone-400 hover:text-white"><InstagramLogo size={20} /></a>}
            {social.facebook && <a href={social.facebook} aria-label="Facebook" className="text-stone-400 hover:text-white"><FacebookLogo size={20} /></a>}
            {social.youtube && <a href={social.youtube} aria-label="YouTube" className="text-stone-400 hover:text-white"><YoutubeLogo size={20} /></a>}
          </div>
        </div>
        <Col title="Explore" navigate={navigate} links={[
          { label: "Farmhouses", to: "/farmhouses" }, { label: "Resorts", to: "/resorts" },
          { label: "Banquet Halls", to: "/banquet-halls" }, { label: "Function Halls", to: "/function-halls" },
        ]} />
        <Col title="Company" navigate={navigate} links={[
          { label: "About Us", to: "/about" }, { label: "Contact", to: "/contact" }, { label: "List Your Property", to: "/list-your-property" },
        ]} />
        <Col title="Support" navigate={navigate} links={[
          { label: "Help Center", to: "/help" }, { label: "Cancellation Policy", to: "/cancellation-policy" },
          { label: "Refund Policy", to: "/refund-policy" },
        ]} />
        <div>
          <p className="mb-3 text-xs font-bold uppercase tracking-wider text-stone-400">Get in touch</p>
          <div className="space-y-2 text-sm">
            {info.support_whatsapp && <a data-testid="footer-whatsapp" href={waLink(info.support_whatsapp, "Hi Avinya Bookings, I need help.")} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-stone-300 hover:text-white"><WhatsappLogo size={16} weight="fill" className="text-green-500" /> WhatsApp</a>}
            {info.support_email && <a href={`mailto:${info.support_email}`} className="flex items-center gap-2 text-stone-300 hover:text-white"><EnvelopeSimple size={16} /> {info.support_email}</a>}
            {info.business_hours && <p className="text-stone-500">{info.business_hours}</p>}
          </div>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-6xl border-t border-stone-800 pt-6 text-center text-xs text-stone-500">
        <div className="mb-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
          <button data-testid="footer-terms" onClick={() => navigate("/terms")} className="hover:text-stone-300">Terms</button>
          <button data-testid="footer-privacy" onClick={() => navigate("/privacy")} className="hover:text-stone-300">Privacy</button>
          <button data-testid="footer-refund" onClick={() => navigate("/refund-policy")} className="hover:text-stone-300">Refund Policy</button>
          <button data-testid="footer-cancellation" onClick={() => navigate("/cancellation-policy")} className="hover:text-stone-300">Cancellation Policy</button>
        </div>
        © {new Date().getFullYear()} Avinya Bookings. All rights reserved.
      </div>
    </footer>
  );
};
